import axios from 'axios';
let globalData = null;
export const isUnCenterLink2Center = () => {
    // 1.migrationSite: true(非中台转中台)
    // 2.url有带参数，并且带的参数里包含 x_ads_source 或者 x_ads_id
    if (!globalData) {
        globalData = window.sitePrepareData();
    }
    let { search } = window.location;
    return (
        !globalData?.isLandingPage &&
        globalData?.migrationSite &&
        search &&
        search.indexOf('condition=') === -1 &&
        (search.indexOf('x_ads_source') > -1 || search.indexOf('x_ads_id') > -1)
    );
};

export const unCenterLink2CenterParams = params => {
    let searchParams = { ...params };
    if (isUnCenterLink2Center()) {
        delete searchParams.condition;
    }
    // console.groupCollapsed(
    //     'searchRealTimeListings unCenterLink2CenterParams:',
    //     searchParams
    // );
    // console.trace();
    // console.groupEnd();
    return searchParams;
};

export const searchRealTimeListings = params => {
    // console.groupCollapsed('searchRealTimeListings:', params);
    // console.trace();
    // console.groupEnd();
    return axios.get('/api-site/search/realTimeListings', { params });
};

export const handleConditionParams = params => {
    return unCenterLink2CenterParams(params);
};
